<script setup lang="ts">
const { trackEvent } = useGAnalytics();
const isOpen = ref(false);
const { locales } = useI18n();
const switchLocalePath = useSwitchLocalePath();
const i18nCookie = useCookie("i18n_redirected");
const switchLocale = (locale: string) => {
  i18nCookie.value = locale;
  const newPath = switchLocalePath(locale as any);
  window.location.href = newPath;
};

const getLocaleName = (locale: string) => {
  return locales.value.find((l) => l.code === locale)?.name;
};
</script>
<template>
  <HeadlessPopover class="relative text-neutral-200 mt-1">
    <HeadlessPopoverButton class="focus:outline-hidden">
      <div
        class="flex items-center gap-2 border border-secondary-500 rounded-md p-2"
        @click="isOpen = !isOpen">
        <NuxtIcon
          name="mdi:world-wide-web"
          @click="trackEvent('languages_dropdown')"
          alt="notifications"
          class="w-8 h-8" />
        <p class="text-neutral-200">
          {{ getLocaleName($i18n.locale) }}
        </p>
        <NuxtIcon
          name="mdi:chevron-down"
          alt="notifications"
          class="w-8 h-8 transition-transform duration-200 ml-10"
          :class="isOpen ? '-rotate-180' : 'rotate-0'" />
      </div>
    </HeadlessPopoverButton>
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-200"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95">
      <HeadlessPopoverPanel
        v-slot="{ close }"
        class="absolute bottom-[130%] right-0 mt-2 rounded-xl w-40 bg-neutral-800 flex-col z-30 shadow-sm shadow-black border border-secondary-500">
        <div
          class="relativew-full flex flex-col min-h-fit font-semibold py-4 bg-transparent">
          <div class="">
            <div
              class="absolute right-3.5 -bottom-2 translate-y-[0.05rem] w-4 border-solid border-secondary-500 border-t-8 border-x-transparent border-x-8 border-b-0" />
            <div
              class="absolute right-3.5 -bottom-2 translate-y-[-0.05rem] w-4 border-solid border-neutral-800 border-t-8 border-x-transparent border-x-8 border-b-0" />
          </div>
          <template v-for="locale in locales" :key="locale">
            <div
              class="flex justify-between items-center cursor-pointer hover:text-primary-500 pl-4 pr-1.5 py-2 mx-2 hover:bg-neutral-500 rounded-sm"
              :class="
                locale.code === $i18n.locale
                  ? ' text-primary-500 font-bold bg-neutral-500'
                  : ' text-neutral-200'
              "
              @click="switchLocale(locale.code), close()">
              <p>
                {{ locale.name }}
              </p>
              <NuxtIcon
                name="mdi:check"
                v-if="locale.code === $i18n.locale"
                class="w-4 h-4 text-primary-500" />
            </div>
          </template>
        </div>
      </HeadlessPopoverPanel>
    </transition>
  </HeadlessPopover>
</template>
